import { Mapping } from "src/types/primitives";

// tslint:disable-next-line: no-any
export const removeUndefinedValues = <T extends any>(obj: Mapping): T => {
  const tmp = {};

  for (const [name, value] of Object.entries(obj)) {
    if (typeof value !== "undefined") {
      tmp[name] = value;
    }
  }

  return tmp as T;
};
